import { RootState } from '@store/store'
import { prop } from 'ramda'
import { createSelector } from 'reselect'

import {
  CONFERENCE,
  CONFERENCE_ALL,
  CONFERENCE_ARTICLE_BY_ID,
  CONFERENCE_ARTICLE_ALL,
  CONFERENCE_ARTICLE_CREATE,
  CONFERENCE_CATEGORY_ALL,
  GLOBAL_STATE,
} from '../constants/actionTypes'

const conferenceSelectors = (state: RootState) => prop(GLOBAL_STATE, state)

export const conferenceSelector = createSelector(conferenceSelectors, prop(CONFERENCE))

export const conferenceArticleSelector = createSelector(conferenceSelectors, prop(CONFERENCE_ARTICLE_BY_ID))

export const conferenceArticleCreateSelector = createSelector(conferenceSelectors, prop(CONFERENCE_ARTICLE_CREATE))

export const conferenceArticleAllSelector = createSelector(conferenceSelectors, prop(CONFERENCE_ARTICLE_ALL))

export const conferenceCategoryAllSelector = createSelector(conferenceSelectors, prop(CONFERENCE_CATEGORY_ALL))

export const conferenceAllSelector = createSelector(conferenceSelectors, prop(CONFERENCE_ALL))
